(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-bride-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const states = new WeakMap();
  function setup(root) {
    if (states.has(root)) return;
    const track = root.querySelector('[data-fs-track]');
    const template = root.querySelector('[data-fs-cards]');
    if (!track || !template) return;
    const cards = Array.from(template.content.children);
    const more = root.querySelector('[data-fs-more]');
    const toggle = root.querySelector('[data-fs-toggle]');
    const controller = new AbortController();
    const signal = controller.signal;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const rtl = root.dir === 'rtl';
    let initialized = false, visible = false, hovered = false, touching = false;
    let paused = reduced.matches, loaded = 0, timer = null, frame = null;
    let nearObserver, visibleObserver, imageObserver;
    const initialCount = () => window.innerWidth <= 749 ? 2 : window.innerWidth <= 990 ? 3 : window.innerWidth <= 1279 ? 5 : 6;
    function stop() { if (timer !== null) clearInterval(timer); timer = null; }
    function loadImage(img) {
      if (!img.dataset.src) return;
      img.addEventListener('error', () => {
        const card = img.closest('.fs-sp-card');
        if (card) card.hidden = true;
        if (loaded < cards.length) appendBatch(1);
      }, {once:true, signal});
      img.src = img.dataset.src;
      delete img.dataset.src;
    }
    if ('IntersectionObserver' in window) {
      imageObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          loadImage(entry.target);
          imageObserver.unobserve(entry.target);
        });
      }, {root:track, rootMargin:'0px 100px', threshold:0});
    }
    function loadVisibleImages() {
      const bounds = track.getBoundingClientRect();
      track.querySelectorAll('img[data-src]').forEach(img => {
        const box = img.getBoundingClientRect();
        if (box.right >= bounds.left - 100 && box.left <= bounds.right + 100) loadImage(img);
      });
    }
    function appendBatch(count = 3) {
      const end = Math.min(cards.length, loaded + count);
      const fragment = document.createDocumentFragment();
      const images = [];
      while (loaded < end) {
        const card = cards[loaded++].cloneNode(true);
        card.querySelectorAll('img[data-src]').forEach(img => images.push(img));
        fragment.append(card);
      }
      track.append(fragment);
      images.forEach(img => imageObserver?.observe(img));
      loadVisibleImages();
      more.hidden = loaded >= cards.length;
    }
    function syncToggle() {
      if (!toggle) return;
      toggle.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
      toggle.setAttribute('aria-pressed', String(paused));
    }
    function initialize() {
      if (initialized) return;
      initialized = true;
      appendBatch(initialCount() + 1);
      start();
    }
    function move(forward) {
      initialize();
      const first = track.querySelector('.fs-sp-card:not([hidden])');
      if (!first) return;
      const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 12);
      const position = Math.abs(track.scrollLeft);
      let max = Math.max(0, track.scrollWidth - track.clientWidth);
      if (forward && loaded < cards.length && position + step >= max - step) {
        appendBatch();
        max = Math.max(0, track.scrollWidth - track.clientWidth);
      }
      const target = forward ? (position >= max - 5 ? 0 : Math.min(max, position + step)) : Math.max(0, position - step);
      track.scrollTo({left:(rtl ? -1 : 1) * target, behavior:reduced.matches ? 'auto' : 'smooth'});
    }
    function start() {
      stop();
      if (root.dataset.autoplay !== 'true' || !initialized || !visible || document.hidden || paused || hovered || touching || root.contains(document.activeElement)) return;
      timer = setInterval(() => move(true), 4600);
    }
    function checkProgress() {
      if (!initialized) return;
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const position = Math.min(max, Math.abs(track.scrollLeft));
      const last = track.lastElementChild;
      const bounds = track.getBoundingClientRect();
      const lastBounds = last?.getBoundingClientRect();
      const nearEnd = lastBounds && (rtl
        ? lastBounds.left >= bounds.left - track.clientWidth * 0.5
        : lastBounds.right <= bounds.right + track.clientWidth * 0.5);
      if (loaded < cards.length && (max <= 2 || max - position <= track.clientWidth * 0.5 || nearEnd)) appendBatch();
      loadVisibleImages();
    }
    function scheduleProgress() {
      if (frame !== null) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        checkProgress();
      });
    }
    track.addEventListener('scroll', scheduleProgress, {passive:true, signal});
    track.addEventListener('scrollend', scheduleProgress, {passive:true, signal});
    track.addEventListener('wheel', scheduleProgress, {passive:true, signal});
    track.addEventListener('touchmove', scheduleProgress, {passive:true, signal});
    track.addEventListener('touchend', scheduleProgress, {passive:true, signal});
    track.addEventListener('pointerup', scheduleProgress, {passive:true, signal});
    more.addEventListener('click', () => {
      initialize();
      const previousCount = loaded;
      appendBatch();
      const card = track.children[previousCount];
      if (card) {
        const box = card.getBoundingClientRect();
        const bounds = track.getBoundingClientRect();
        const delta = rtl ? box.right - bounds.right : box.left - bounds.left;
        track.scrollTo({left:track.scrollLeft + delta, behavior:reduced.matches ? 'auto' : 'smooth'});
      }
    }, {signal});
    root.querySelector('.fs-sp-next').addEventListener('click', () => move(true), {signal});
    root.querySelector('.fs-sp-prev').addEventListener('click', () => move(false), {signal});
    track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      move(rtl ? event.key === 'ArrowLeft' : event.key === 'ArrowRight');
    }, {signal});
    toggle?.addEventListener('click', () => {paused=!paused;syncToggle();start();}, {signal});
    root.addEventListener('mouseenter', () => {hovered=true;stop();}, {signal});
    root.addEventListener('mouseleave', () => {hovered=false;start();}, {signal});
    root.addEventListener('focusin', stop, {signal});
    root.addEventListener('focusout', () => requestAnimationFrame(() => {if(root.isConnected) start();}), {signal});
    root.addEventListener('touchstart', () => {touching=true;stop();}, {passive:true,signal});
    root.addEventListener('touchend', () => {touching=false;start();}, {passive:true,signal});
    root.addEventListener('touchcancel', () => {touching=false;start();}, {passive:true,signal});
    document.addEventListener('visibilitychange', start, {signal});
    window.addEventListener('resize', () => {if(initialized && loaded < initialCount() + 1) appendBatch(initialCount() + 1-loaded);scheduleProgress();}, {signal});
    reduced.addEventListener('change', () => {if(reduced.matches) paused=true;syncToggle();start();}, {signal});
    syncToggle();
    states.set(root, () => {stop();controller.abort();if(frame!==null) cancelAnimationFrame(frame);nearObserver?.disconnect();visibleObserver?.disconnect();imageObserver?.disconnect();states.delete(root);});
    if ('IntersectionObserver' in window) {
      nearObserver = new IntersectionObserver(entries => {
        if(entries.some(entry => entry.isIntersecting)){initialize();nearObserver.disconnect();}
      }, {rootMargin:'200px 0px'});
      visibleObserver = new IntersectionObserver(entries => {visible=entries[0].isIntersecting;start();}, {threshold:0.05});
      nearObserver.observe(root);
      visibleObserver.observe(root);
    } else {visible=true;initialize();}
  }
  const setupAll = scope => scope.querySelectorAll('[data-fs-reviews]').forEach(setup);
  setupAll(document);
  document.addEventListener('shopify:section:load', event => setupAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-fs-reviews]').forEach(root => states.get(root)?.());
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
